var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0036 33.3909C29.6574 15.8356 42.2378 0.365452 62.5849 12.0523C73.2854 18.1983 93.7888 36.5171 99.2166 54.7358C107.537 69.2544 95.3356 84.5068 89.9089 93.8575C78.4628 113.58 54.3914 103.697 34.0443 92.0104C13.6972 80.3236 3.5575 53.1139 15.0036 33.3909Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2581 48.3721C31.1718 50.4043 33.913 54.5626 37.5679 54.9378C42.1365 55.4068 63.6091 54.9378 65.4366 54.9378C66.8986 54.9378 68.7869 53.6872 69.5484 53.0619",
    stroke: "#EF533F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8517 71.4048C98.3794 71.4048 102.065 68.2015 102.065 64.9981C102.065 61.7948 101.604 56.3033 92.8517 54.0152C84.0994 51.7271 82.2569 52.1847 71.2014 44.8628C60.1459 37.5408 52.7756 39.3713 43.5627 38.9136C34.3497 38.456 25.1368 44.4051 22.373 47.1508C20.1619 49.3474 16.8452 50.2016 15.4633 50.3542C13.6207 50.3542 9.93555 51.8186 9.93555 57.6762C9.93555 63.5337 13.0065 67.7438 14.542 69.1167",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7164 65.6668C23.273 63.7084 27.4903 60.3791 31.9056 62.7292C37.4248 65.6668 37.8494 71.5418 36.1511 74.4794C34.4529 77.417 27.6601 79.9349 23.8391 76.5777C20.7823 73.8919 20.5842 69.8632 20.8672 68.1846",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9236 62.8811C74.1476 63.045 72.2486 67.7896 71.8961 70.1415L72.3964 72.6175C72.9641 74.1338 75.0525 77.3558 78.8647 78.1139C83.63 79.0615 88.0477 73.7606 88.0495 70.5355C88.0513 67.3104 84.8935 62.6762 78.9236 62.8811Z",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3334 70C59.526 70 47.0401 70 43.5557 70",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H112V112H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.68ed5d6e1e2d6079124e5ab43afef27c.svg";
export { ForwardRef as ReactComponent };